import { v4 as uuidv4 } from 'uuid'
import type { ModelMeta } from '../stores/modelLibrary'
import type { ImportedModelConfig, SceneObject } from '../types/scene'

/** 从模型库元数据创建场景中的导入模型对象（点击放置与拖放共用） */
export function createImportedSceneObjectFromLibraryMeta(
  meta: ModelMeta,
  position: [number, number, number]
): SceneObject {
  const importedModel: ImportedModelConfig = {
    format: meta.format as ImportedModelConfig['format'],
    source: 'library',
    libraryId: meta.libraryId,
    originalFilename: meta.originalFilename,
    unitScale: meta.unitScale ?? 1,
  }
  return {
    id: uuidv4(),
    type: 'imported_model',
    name: meta.name,
    position,
    rotationY: 0,
    params: { userScale: 1 },
    label: { text: meta.name, visible: true },
    importedModel,
  }
}
